import React from 'react';
import { Card, CardBody, CardText, CardTitle } from 'reactstrap';

export type ErrorCardProps = { error: any };
const ErrorCard = ({ error }: ErrorCardProps) => {
  return (
    <Card>
      <CardBody className="d-flex flex-column flex-column">
        <CardTitle>Opps, sorry about that.</CardTitle>
        <CardText>
          It looks like something has gone wrong! <br />
          If you could please submit some feedback, that would be appreciated
        </CardText>
      </CardBody>
    </Card>
  );
};
export default ErrorCard;
